"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Replaces all values in an array using the passed `replacer` function.
 *
 * @param array The array to transform.
 * @param condition The condition function used to determine which values to replace.
 * @param replace The replacer function that returns the replacement values.
 */
function replaceWhere(array, condition, replace) {
    return array.map((value, i) => {
        if (condition(value, i, array)) {
            return replace(value, i, array);
        }
        return value;
    });
}
exports.default = replaceWhere;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVwbGFjZVdoZXJlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxzL2FycmF5L3JlcGxhY2VXaGVyZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUdBOzs7Ozs7R0FNRztBQUNILFNBQXdCLFlBQVksQ0FDbEMsS0FBVSxFQUNWLFNBQXVCLEVBQ3ZCLE9BQXVCO0lBRXZCLE9BQU8sS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUUsRUFBRTtRQUM1QixJQUFJLFNBQVMsQ0FBQyxLQUFLLEVBQUUsQ0FBQyxFQUFFLEtBQUssQ0FBQyxFQUFFO1lBQzlCLE9BQU8sT0FBTyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUUsS0FBSyxDQUFDLENBQUM7U0FDakM7UUFDRCxPQUFPLEtBQUssQ0FBQztJQUNmLENBQUMsQ0FBQyxDQUFDO0FBQ0wsQ0FBQztBQVhELCtCQVdDIn0=